import { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Helmet } from "react-helmet";
import BackButton from "../components/BackButton";

export default function QrGenerator() {
  const [text, setText] = useState("https://yourdomain.com");

  const downloadQR = () => {
    const canvas = document.getElementById("qr-gen");
    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");

    const downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = "qr-code.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <>
      <Helmet>
        <title>QR Code Generator - Free Online Tool for Links, Text & More</title>
        <meta
          name="description"
          content="Create QR codes for websites, text, emails, or contact info. Download QR code PNG instantly. Free and easy online QR code generator tool."
        />
        <meta
          name="keywords"
          content="QR code generator, free QR code, generate QR code, create QR code, online QR code tool, download QR code PNG, QR code for text, QR code for link, QR code for email"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://freelity.com/qr-code-generator" />
      </Helmet>

      <section className="sec-free-tools">
        <div className="container">
          <BackButton />
          <h2>QR Code Generator</h2>
          <p>Enter text or a link below and generate your QR Code instantly.</p>

          <input
            type="text"
            className="form-control mb-3"
            placeholder="Enter text or URL"
            value={text}
            onChange={(e) => setText(e.target.value)}
          />

          <div className="text-center my-4">
            <QRCodeCanvas
              id="qr-gen"
              value={text}
              size={200}
              bgColor="#ffffff"
              fgColor="#000000"
              level="H"
              includeMargin={true}
            />
          </div>

          <div className="text-center">
            <button className="btn btn-success" onClick={downloadQR}>
              Download QR Code
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
